export default __webpack_public_path__ + "static/media/KiwiMaru-Regular.859c4dca.ttf";